<form #modal [formGroup]="form">
    <div class="modal-header">
        <h2 class="headline m-0" fxFlex="auto">{{"ask_vendor"|translate}}</h2>
        <button class="btn-close" aria-label="Close" (click)="bsModalRef.hide()">
        </button>
    </div>

    <div class="modal-body">
        <div *ngIf="product" fxLayout="column">
            <div fxFlex="30%" class="p-2">
                <img fxFlex="30%" *ngIf="product.images" [src]="product.images[imagebObjectKey(product.images)]?.url" />
            </div>
            <h1 class="p-2">{{ product.name[this.translate.currentLang] }}</h1>
        </div>
        <form [formGroup]="form">
            <div class="text-hint overflow-hidden bg-card ltr:pl-6 rtl:pr-6" fxFlex="auto" fxLayout="row"
                fxLayoutAlign="start center">
                <input class="form-control card-radius-x1 " formControlName="msg" placeholder="Your message..."
                    type="text">
                <button mat-icon-button type="button" (click)="fileInput.click()">
                    <mat-icon>photo</mat-icon>
                    <input #fileInput type="file" (change)="fileBrowseHandler($event.target.files)"
                        style="display:none;" accept="image/x-png,image/gif,image/jpeg" />
                </button>
            </div>
        </form>
        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 mt-2">
            <div *ngFor="let file of files;let i=index">
                <button class="pull-right float-left close" aria-label="Close" (click)="deletePicture(i)">
                    <app-icon name="cross-20" size="20"></app-icon>
                </button>
                <img class="img-thumbnail m-2" style="height:100px;width:100px" [src]="file.url" alt="">
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button mat-flat-button (click)="bsModalRef.hide()" type="button">{{"cancel"|translate}}</button>
        <button mat-flat-button type="button" color="primary" (click)="save()">{{"ask_vendor"|translate}}</button>
    </div>
</form>
